const Home = () => (
  <div className="page home-page">
    <div className="profile-container">
      <img src="/profile.png" alt="Buio Profile" className="profile-pic" />
    </div>
    <h1 className="home-name">Ciao, I'm Buio</h1>
    <p className="home-role">SOC Analyst @ CommSec</p>
    <p className="home-subtitle">Cyber Security & Digital Forensics graduate based in Ireland.</p>
  </div>
);

export default Home;
